export default "__VITE_ASSET__C$lESVnL__"